import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, from, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import * as Parse from 'parse';
import { ParseUser } from 'app/core/user/parse-user.model';

@Injectable({
  providedIn: 'root'
})
export class EmailTemplateManagerGuard {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkRole();
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkRole();
  }

  private checkRole(): Observable<boolean> {
    const user = ParseUser.current() as ParseUser;

    if (!user) {
      this.router.navigate(['sign-in']);
      return of(false);
    }

    return from(Parse.Cloud.run('isEmailTemplateManager', {})).pipe(
      switchMap((isManager: boolean) => {
        if (!isManager) {
          this.router.navigate(['dashboard']);
          return of(false);
        }
        return of(true);
      }),
      catchError(() => {
        this.router.navigate(['dashboard']);
        return of(false);
      })
    );
  }
}
